import pearClient from 'apis/pearClient';
import CircularLoader from 'components/common/CircularLoader';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-router-dom';
import { iframePostMessage } from 'utils/constants';
import { sessionGet, SessionKeys } from 'utils/tokenStorage';

const LessonSummaries = () => {
  const [content, setContent] = useState<any>();

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  const documentLocale = useQuery().get('locale') || 'en';

  const fetchCombinedModuleSummaries = async (locale: string) => {
    const response = await pearClient.assets.fetchCombinedModuleSummaries(
      locale,
    );
    setContent(response);
  };

  useEffect(() => {
    if (!content) {
      fetchCombinedModuleSummaries(documentLocale);
    }

    setTimeout(() => {
      const iframeHeight = window.document.body.clientHeight;

      if (window && window.parent) {
        window.parent.postMessage(
          {
            payload: {
              action: iframePostMessage.UPDATE_CONTENT_HEIGHT,
              contentHeight: iframeHeight,
            },
          },
          sessionGet(SessionKeys.ORIGIN)!,
        );
      }
    }, 1000);
  }, [content, documentLocale]);

  return content ? (
    <div data-testid="documents-lesson-summaries">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  ) : (
    <CircularLoader />
  );
};

export default LessonSummaries;
